import GoodPracticeHeader from "./components/GoodPracticeHeader";

export default GoodPracticeHeader;